import styled, { css } from 'styled-components';

export const Limiter = styled.div`
  margin: -5px 0 30px;
  padding: 8px 10px;
  position: relative;
  min-height: 60px;
  ${(props) =>
    props.$loading &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: rgba(14, 21, 24, 0.72) url('/images/loader2.svg') no-repeat 50% 50%;
        background-size: 20px auto;
        border-radius: 8px;
      }
    `}
`;

export const LimiterItem = styled.div`
  margin: 7px 0 0;
  display: flex;
  align-items: center;
  label {
    cursor: pointer;
    margin: 0 0 0 10px;
    &.left-side {
      margin: 0 10px 0 0;
    }
  }
  input {
    font-size: 15px;
    padding: 6px 8px;
    width: 48px;
    background: #1a2429;
    color: #e6eaec;
    border: 1px solid #3d4952;
    border-radius: 8px;
    font-family: inherit;
  }
  [type='checkbox'] {
    cursor: pointer;
    width: 17px;
    height: 17px;
  }
`;

export const NumberBox = styled.div`
  display: inline-flex;
  align-items: stretch;
  height: 34px;
  border: 1px solid #3d4952;
  border-radius: 8px;
  background: #1a2429;
  overflow: hidden;
  input {
    -webkit-appearance: none;
    -moz-appearance: textfield;
    appearance: textfield;
    border: 0 !important;
    background: transparent !important;
    color: #e6eaec;
    width: 38px !important;
    text-align: center;
    font-size: 15px;
    padding: 0 !important;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
  .steps {
    display: flex;
    flex-direction: column;
    width: 22px;
    border-left: 1px solid #3d4952;
  }
  .steps button {
    flex: 1;
    border: 0;
    background: #232e35;
    color: #aab2b8;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    transition: background 0.12s ease, color 0.12s ease;
    &:hover {
      background: #47b972;
      color: #ffffff;
    }
    &:first-child {
      border-bottom: 1px solid #3d4952;
    }
    svg {
      width: 9px;
      height: 9px;
    }
  }
`;

export const ToggleWrapper = styled.div`
  label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .toggle-input {
    opacity: 0;
    width: 0;
    height: 0;
    margin: 0;

    &:checked + span {
      background-color: #47b972;
    }
    &:checked + span:before {
      transform: translateX(18px);
    }
  }

  .toggle-slider {
    position: relative;
    width: 40px;
    height: 22px;
    cursor: pointer;
    display: inline-block;
    background: #3d4952;
    border-radius: 22px;
    margin-right: 12px;
    vertical-align: middle;
    transition: background 0.3s;

    &::before {
      position: absolute;
      content: '';
      height: 18px;
      width: 18px;
      left: 2px;
      top: 2px;
      background: #fff;
      border-radius: 50%;
      transition: 0.3s;
    }
  }
`;
